import { get } from 'lodash';
import { CURRENT_PRODUCT_MODE, DEFAULT_METRIC } from '@utils/constants';
import { genEIUsecases } from './configs/ei';
import { DEFAULT_DIMENSIONS } from '@store/trends/base/reducer';
import { genAIUsecases } from './configs/ai';
import { GRANULARITY } from '@utils/granularity';
import {
  genAppUsecases,
  generateEcoFlowUsecases,
  generateEcoFrustrationSignalUsecases,
  generateEcoEventUsecase,
} from './configs/eco';

const generateUsecaseConfig = {
  EI: genEIUsecases,
  AI: genAIUsecases,
  APP: genAppUsecases,
}[CURRENT_PRODUCT_MODE];

export const getValidateMetricFunc = (validMetricMeta: object) => (metricToCheck: string) => {
  if (Array.isArray(metricToCheck)) {
    return metricToCheck.filter((m) => m in validMetricMeta);
  } else {
    return metricToCheck in validMetricMeta ? metricToCheck : DEFAULT_METRIC[CURRENT_PRODUCT_MODE];
  }
};

export const getValidateDimensionFunc =
  (validDimensionList: { field: string; [key: string]: unknown }[]) =>
  (dimensionToCheck: string[] | string) => {
    if (Array.isArray(dimensionToCheck)) {
      const validDimensionFields = validDimensionList.map((obj) => obj.field);
      const filtered = dimensionToCheck.filter((d) => validDimensionFields.includes(d));

      return filtered.length > 0 ? filtered : DEFAULT_DIMENSIONS[CURRENT_PRODUCT_MODE];
    } else {
      return dimensionToCheck in validDimensionList
        ? dimensionToCheck
        : DEFAULT_DIMENSIONS[CURRENT_PRODUCT_MODE][0];
    }
  };

export const buildUsecases = (metrics, dimensions) => {
  try {
    return generateUsecaseConfig({
      validateMetric: getValidateMetricFunc(metrics),
      validateDimension: getValidateDimensionFunc(dimensions),
    });
  } catch (err) {
    // pass
  }

  return [];
};

export const buildFlowUsecases = (metrics, dimensions, flowConfigMeta = {}) => {
  try {
    return generateEcoFlowUsecases({
      metrics,
      validateDimension: getValidateDimensionFunc(dimensions),
      flowConfigMeta,
    });
  } catch (err) {
    // pass
  }

  return [];
};

export const buildFrustrationSignalUsecases = (
  metrics,
  dimensions,
  frustrationSignalConfigMeta = {},
) => {
  try {
    return generateEcoFrustrationSignalUsecases({
      metrics,
      validateDimension: getValidateDimensionFunc(dimensions),
      frustrationSignalConfigMeta,
    });
  } catch (err) {
    // pass
  }

  return [];
};

export const buildEventUsecase = (metrics, dimensions, eventConfigMeta = {}) => {
  try {
    return generateEcoEventUsecase({
      metrics,
      validateDimension: getValidateDimensionFunc(dimensions),
      eventConfigMeta,
    });
  } catch (err) {
    // pass
  }

  return {};
};

export function formatPresetConfig(presetConfig, isFlow = false) {
  try {
    return {
      filter: get(presetConfig, 'common.appliedFilters[0]', []),
      granularity: get(
        presetConfig,
        'common.granularity',
        isFlow ? GRANULARITY.PT15M : GRANULARITY.PT1M,
      ),
      chartMetrics: get(presetConfig, 'metricsChartContainer.metrics', []),
      selectedMetric: get(presetConfig, 'metricsChartContainer.metric', 'Attempts'),
      dimensionKeys: get(presetConfig, `['module:trends'].base.dimensions`, []),
      summaryWidgets: get(presetConfig, 'summaryWidgets', undefined),
      metricPanel: get(presetConfig, 'metricPanel', {}),
      widgetState: get(presetConfig, 'widgetState', {}),
      atomState: get(presetConfig, 'atomState', undefined),
    };
  } catch (error) {
    return {};
  }
}
